import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "md:flex md:flex-row" }
const _hoisted_2 = {
  key: 0,
  class: "w-full md:flex-1"
}
const _hoisted_3 = { class: "my-gutter self-center md:flex-1 lg:my-0" }
const _hoisted_4 = { class: "px-25 max-w-750 mx-auto lg:px-40 md:max-w-600 xl:px-25 xxl:max-w-700" }
const _hoisted_5 = {
  key: 0,
  class: "mb-10"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MediaHandler = _resolveComponent("MediaHandler")!
  const _component_c_icon = _resolveComponent("c-icon")!
  const _component_DisclosureButton = _resolveComponent("DisclosureButton")!
  const _component_DisclosurePanel = _resolveComponent("DisclosurePanel")!
  const _component_Disclosure = _resolveComponent("Disclosure")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showMedia)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_MediaHandler, {
            "media-aspect-ratio": {'default': 1/1},
            "video-autoplay-override": _ctx.content.autoPlay,
            "image-width-on-screen": {
                    xs: 100,
                    sm: 50,
                },
            "image-zoom-override": _ctx.content.zoom,
            "media-block": _ctx.content.media
          }, null, 8, ["video-autoplay-override", "image-zoom-override", "media-block"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        (_ctx.content.title)
          ? (_openBlock(), _createElementBlock("h2", _hoisted_5, _toDisplayString(_ctx.content.title), 1))
          : _createCommentVNode("", true),
        (_ctx.content.text)
          ? (_openBlock(), _createElementBlock("p", {
              key: 1,
              class: "mb-40",
              innerHTML: _ctx.content.text
            }, null, 8, _hoisted_6))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.questionAndAnswers, (qa, index) => {
          return (_openBlock(), _createBlock(_component_Disclosure, {
            key: `${qa.model.title}-${index}`,
            as: "div",
            class: "mb-20 relative"
          }, {
            default: _withCtx(({ open }) => [
              _createVNode(_component_DisclosureButton, { class: "flex justify-between items-center w-full text-left relative" }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", {
                    class: "o-text-body font-bold w-full pr-30 lg:pr-120 xl:pr-50",
                    innerHTML: qa.model.title
                  }, null, 8, _hoisted_7),
                  _createVNode(_component_c_icon, {
                    name: "icon-minus",
                    "aria-hidden": "true",
                    class: "absolute right-0 top-0 h-18 lg:h-20"
                  }),
                  _createVNode(_component_c_icon, {
                    name: "icon-minus",
                    "aria-hidden": "true",
                    class: _normalizeClass(["absolute right-0 top-0 transition-all duration-300 h-18 lg:h-20", {'rotate-0 opacity-0': open, 'rotate-90': !open}])
                  }, null, 8, ["class"])
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_DisclosurePanel, {
                class: "o-text-caption magic-line-on-child-links mt-6 pr-30 lg:pr-120 xl:pr-50",
                innerHTML: qa.model.text
              }, null, 8, ["innerHTML"])
            ]),
            _: 2
          }, 1024))
        }), 128))
      ])
    ])
  ]))
}